// Revival: rotates the messages in an announcement bar or promo strip ([data-rv-rot]).
// One message shows at a time; autoplay every data-interval seconds, pauses on hover/focus, stops for reduced motion.
(function () {
  function init(root) {
    if (root.__rvRot) return; root.__rvRot = true;
    var items = root.querySelectorAll('[data-rv-rot-item]');
    if (items.length < 2) { if (items[0]) items[0].classList.add('is-on'); return; }
    var i = 0, paused = false, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ms = (+root.getAttribute('data-interval') || 5) * 1000;
    function show(n) {
      items[i].classList.remove('is-on'); items[i].setAttribute('aria-hidden', 'true');
      i = (n + items.length) % items.length;
      items[i].classList.add('is-on'); items[i].removeAttribute('aria-hidden');
    }
    items.forEach(function (el, n) { if (n) el.setAttribute('aria-hidden', 'true'); });
    items[0].classList.add('is-on');
    var prev = root.querySelector('[data-rv-rot-prev]'), next = root.querySelector('[data-rv-rot-next]');
    if (prev) { prev.hidden = false; prev.addEventListener('click', function () { show(i - 1); restart(); }); }
    if (next) { next.hidden = false; next.addEventListener('click', function () { show(i + 1); restart(); }); }
    function restart() { clearInterval(timer); if (!reduce) timer = setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, ms); }
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    restart();
  }
  function boot() { document.querySelectorAll('[data-rv-rot]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
